import {
    Box,
    Container,
    SimpleGrid,
    Icon,
    Stack,
    HStack,
    VStack,
  } from '@chakra-ui/react';
  import {Fade,Slide} from "react-awesome-reveal"

  import { motion } from "framer-motion"
  import {FaTools} from "react-icons/fa"
import Heading from './Heading';
import Text from './Text';
import { Tokens } from '../mirrorful/theme';
 import "../components/Skills.scss"
  import "./Skills.css"

  const features=[{id:0, title:'Adaptability and flexibility'},{id:1,title:'Attention to detail'},{id:2,title:'Problem-solving and troubleshooting'},{id:3,title:'Self-motivation and proactivity'},
  {id:4,title:'Teamwork and collaboration'},{id:5,title:'Empathy and user-centric mindset'},
  {id:6,title:'Critical thinking'},{id:7,title:'Research and learning agility'}
  ]

  export default function SoftSkills() {


    return (
      <Box p={4} textAlign={"left"} >
        <Stack spacing={4} as={Container} maxW={'6xl'}>
        <Heading
        text={`Other Skills`}
        style={{ marginTop: '64px' ,textAlign:'center' }}
        size="lg"
        />
          <Text textAlign={"left"} color={'gray.600'} fontSize={'xl'}>
          As a web developer, I am constantly seeking opportunities to expand my skill set and stay up-to-date with the latest technologies and trends in the industry. I have a strong passion for continuous learning and strive to enhance my adaptability, problem-solving abilities, and knowledge sharing capabilities
          </Text>
        </Stack>
  
        <Container maxW={'6xl'} mt={10} >
          <SimpleGrid columns={1} spacing={10}>
  
            {features.map((feature,index) => (
             <motion.nav
             key={index}
             initial={{ opacity: 0, y: 20 }}
             animate={{ opacity: 1, y: 0 }}
             transition={{ duration: 0.5, delay: index * 0.2 }}
           >
             <HStack className="extend-trigger" key={feature.id} align={'top'} alignItems={"center"}>
                <Box 
                >
                  <Icon color={"white"} as={FaTools}/>
                </Box>
                <VStack align={'start'}>
                  <Text as="i" fontWeight={600}>{feature.title}</Text>
                </VStack>
              
              </HStack>
              {/* <Slide left duration={2000}> */}
              <div className='container'>
      
    </div>
            {/* </Slide> */}
            </motion.nav>
              
            ))}
          </SimpleGrid>
        </Container>

      </Box>
      
    );
  }